import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import {
  clearFilterJadaiReceipt,
  clearJadaiReceiptDetail,
  setFilterJadaiReceipt,
  setJadaiReceiptID,
} from "./jadaiReceiptSlice";
import {
  deleteJadaiReceipt,
  findAllJadaiReceipt,
} from "./services/jadaireceipt.services";
import { FaEye } from "react-icons/fa";

const JadaiReceipt: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
      dispatch(closeDialog());
      dispatch(clearJadaiReceiptDetail());
    };
  }, []);

  const handleProcessCreate = () => {
    navigate("/jadaireceipt/create");
  };

  return (
    <>
      <DeleteJadaiReceiptDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Jadai Receipt
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleProcessCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <JadaiReceiptGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const JadaiReceiptGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const JadaiReceiptList = useAppSelector(
    (state) => state.jadaireceipt.JadaiReceiptList,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const loading = useAppSelector((state) => state.jadaireceipt.loading);

  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  const FilterJadaiReceipt = useAppSelector(
    (state) => state.jadaireceipt.FilterJadaiReceipt,
  );

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  useEffect(() => {
    const payload = {
      ...FilterJadaiReceipt,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(findAllJadaiReceipt(payload));
  }, [currentPage, pageLimit]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEditItem = (jadai_receipt_guid: string) => {
      navigate("/jadaireceipt/edit", {
        state: { jadai_receipt_guid: jadai_receipt_guid },
      });
    };

    const handlePrint = (jadai_receipt_guid: string) => {
      window.open(`/jadaireceipt/${jadai_receipt_guid}`, "_blank");
    };

    const handleOpenDeleteDialog = (ID: any) => {
      dispatch(openDialog("delete-jadai-receipt"));
      dispatch(setJadaiReceiptID(ID));
    };

    return (
      <td className="action-td">
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            themeColor="success"
            onClick={() => handleEditItem(props.dataItem?.jadai_receipt_guid)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem.jadai_receipt_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="View"
            themeColor="tertiary"
            onClick={() => handlePrint(props.dataItem.jadai_receipt_guid)}
          >
            <FaEye className="absolute-position" style={{ fontSize: "24px" }} />
          </IconButton>
        )}
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 5 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const JadaiReceiptFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.jadaireceipt.FilterJadaiReceipt}
        setFilterAction={setFilterJadaiReceipt}
        clearFilterAction={clearFilterJadaiReceipt}
        fetchDataAction={findAllJadaiReceipt}
        pagination={{ case: "lowercase" }}
      />
    ),
    [],
  );
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        scrollable="scrollable"
        filterable={true}
        filter={filter}
        data={filter ? filterBy(JadaiReceiptList, filter) : JadaiReceiptList}
        total={JadaiReceiptList[0]?.itemcount || JadaiReceiptList.length}
        onFilterChange={handleFilterChange}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="receipt_no"
          title="Receipt No"
          cells={{
            data: (props: any) => (
              <td>
                <div
                  className="hoverableName"
                  onClick={() =>
                    navigate("/jadaireceipt/edit", {
                      state: {
                        jadai_receipt_guid: props.dataItem?.jadai_receipt_guid,
                      },
                    })
                  }
                >
                  {props.dataItem?.receipt_no}
                </div>
              </td>
            ),
          }}
        />
        <Column
          field="receipt_date"
          title="Receipt Date"
          cells={{ filterCell: JadaiReceiptFilterCell }}
        />
        <Column
          field="karigar_name"
          title="Karigar Name"
          cells={{ filterCell: JadaiReceiptFilterCell }}
        />

        {(isDeleteAccess || isEditAccess) && (
          <Column
            field="ghat_receipt_guid"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"150px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteJadaiReceiptDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const JadaiReceiptID = useAppSelector(
    (state) => state.jadaireceipt.JadaiReceiptID,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const FilterJadaiReceipt = useAppSelector(
    (state) => state.jadaireceipt.FilterJadaiReceipt,
  );
  const handleDeleteAction = async (ID: any) => {
    if (ID) {
      const response = await dispatch(deleteJadaiReceipt(ID));
      dispatch(setCurrentPage(0));
      const payload = {
        ...FilterJadaiReceipt,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload?.Data.Status === 200) {
        dispatch(findAllJadaiReceipt(payload));
        dispatch(closeDialog());
        dispatch(clearJadaiReceiptDetail());
      } else {
        dispatch(findAllJadaiReceipt(payload));
        dispatch(closeDialog());
        dispatch(clearJadaiReceiptDetail());
      }
    }
  };

  return (
    <>
      {dialogName === "delete-jadai-receipt" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Jadai Receipt?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Jadai Receipt?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(JadaiReceiptID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default JadaiReceipt;
